exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-f76593c4]{color:#fff;cursor:default;font-size:1.2307692308rem}", ""]);

// exports
